import axios from "axios";


export const createStorePlacement = async (placement, store, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/placement?store=${store}`, placement, {
        headers: {
            authtoken,
        },
    });

export const getPlacements = async (store) =>
    await axios.get(`${process.env.REACT_APP_API}/store/placement-list?store=${store}`);

export const getBarcodes = async (store) =>
    await axios.get(`${process.env.REACT_APP_API}/store/barcode-list?store=${store}`);

export const addStorePlacementSub = async (values, store, id, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/placement/add-sub?store=${store}&&id=${id}`, values, {
        headers: {
            authtoken,
        },
    });

export const getPlacementSubs = async (store, id) =>
    await axios.get(`${process.env.REACT_APP_API}/store/placement-subs?store=${store}&&id=${id}`);

export const deletePlacementSub = async (store, id, subId, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/placement-subs/delete?store=${store}&&id=${id}&&subId=${subId}`, {}, {
        headers: {
            authtoken,
        },
    });

export const deletePlacement = async (store, id, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/placement/delete?store=${store}&&id=${id}`, {}, {
        headers: {
            authtoken,
        },
    });


export const deleteStoreBarcode = async (store, id, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/barcodes/delete?store=${store}&&id=${id}`, {}, {
        headers: {
            authtoken,
        },
    });

export const createStoreBarcode = async (values, store, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/store/barcode-create?store=${store}`, values, {
        headers: {
            authtoken,
        },
    });